import css from 'css'

const addIdToCss = (code, id) => {
  const ast = css.parse(code, {silent: true}); // silent => doesn't throw parsing errors
  const errorsNumber = ast.stylesheet.parsingErrors.length;
  const hasParsingErrors = !!errorsNumber;

  if (hasParsingErrors) {
    return {code, errors: hasParsingErrors}
  } else {

    const appendedAst = {
      ...ast,
      stylesheet: {
        ...ast.stylesheet,
        rules: ast.stylesheet.rules.map(rule => ({
          ...rule,
          selectors: rule.selectors.map( selector => selector.includes("@") ? selector : `${id} ${selector}` )
        }))
      }
    }

    const newCss = css.stringify(appendedAst);

    return {code: newCss, errors: hasParsingErrors };
  }
}

export default addIdToCss;



// WEBPACK FOOTER //
// ./src/utils/addIdToCss.js